export const ModelContainerDetail = () => {
	return {
		Model: {
			ContainerId: { value: null },
			ContainerNo: { value: null },
			ContainerType: { value: null },
			Carrier: { value: null },
			Voyage: { value: null },
			PortTerminalId: { value: null, hidden: true },
			PortTerminal: { value: null, hidden: false },
			incidenttype: { value: null, hidden: true },
			incidenttypeId: { value: null, hidden: false },
			dgr: { value: null },
			imo: { value: null },
			Consignee: { value: null },
			From: { value: null },
			To: { value: null },
			FreeDays: { value: null },
			CustomerFreeDays: { value: null },
			ETD: { value: null },
			ATD: { value: null },
			ETA: { value: null },
			ATA: { value: null },
			MaxEmptyReturned: { value: null },
			MaxCarrierEmptyReturned: { value: null },
			OutGate: { value: null },
			DeliveryDestination: { value: null },
			EmptyReturned: { value: null },
			Dimensions: { value: null },
			TotalPieces: { value: null },
			TotalWeight: { value: null },
			TotalVolume: { value: null },
			Cargo: { value: null },
			IncidentDateInfo: { value: null, },
			SiniesterId: { value: null, hidden: true },
			AdditionalCommentInfo: { value: null },
			// SinesterDate: { value: null, hidden: true },
			IncidentType: { value: null },
			AdditionalComment: { value: null },
			IncidentDate: { value: null, hidden: true },
			CreateUserId: { value: null },
			CreateDay: { value: null, hidden: true },
			CreateUser: { value: null, hidden: true },
			ShipmentId: { value: null },
			IncidentId: { value: null },
		},
		// ModelNew: {
		// 	Port: { value: null },
		// 	FreeDays: { value: null },
		// 	MaxEmpty: { value: null },
		// 	MaxCarrierEmpty: { value: null },
		// 	Out: { value: null },
		// 	Delivery: { value: null },
		// 	ActualEmpty: { value: null },
		// },
		Catalogos: {
			IncidentType: [
				{ key: 1, value: 'A', text: 'Abandoned' },
				{ key: 2, value: 'S', text: 'Siniester' },
			]
		}
	};
};